module.exports = __webpack_public_path__ + "static/media/default_user.c26cd415.png";